import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GalaxyAiIconService, GalaxyAiIconSvg } from '@vendasta/galaxy/ai-icon';
import { ChatContainerComponent } from '@vendasta/galaxy/chat';
import { SsoAiChatService } from './sso-ai-chat.service';

interface Message {
  type: string;
  messageFrom: string;
  messageText: string;
  showProfilePic?: boolean;
  profileSVGIcon?: string;
  profileBackgroundColor?: string;
}

@Component({
  selector: 'app-sso-ai-chat',
  templateUrl: './sso-ai-chat.component.html',
  styleUrls: ['./sso-ai-chat.component.scss'],
})
export class SsoAiChatComponent implements OnInit {
  messages: Message[] = [];
  isAIBotLoading: boolean;
  readonly BOT_SVG_ICON = 'galaxy-ai-icon';
  readonly BOT_BACKGROUND_COLOR = '#f6f6f6';
  readonly SENT = 'sent';
  readonly RECEIVED = 'received';
  readonly VENDASTA_SSO_AI = 'Vendasta SSO AI';
  GalaxyAiIconSvg = GalaxyAiIconSvg;

  @ViewChild('chatContainer') chatContainer: ChatContainerComponent;
  @ViewChild('textArea') textArea: ElementRef;

  constructor(
    private ssoAiChatService: SsoAiChatService,
    private _: GalaxyAiIconService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.addBotMessage(this.translate.instant('INTEGRATIONS.SSO_INTEGRATION.WELCOME_CHAT_MESSAGE'));
    this.isAIBotLoading = false;
  }

  private addMessage(message: Message) {
    // messages must be added in reverse order for glxy-chat-container, which
    // renders as column-reverse so content scrolls up and away from the bottom
    this.messages.unshift(message);
  }

  private addBotMessage(messageText: string) {
    this.addMessage({
      type: this.RECEIVED,
      messageFrom: this.VENDASTA_SSO_AI,
      messageText: messageText,
      showProfilePic: true,
      profileSVGIcon: this.BOT_SVG_ICON,
      profileBackgroundColor: this.BOT_BACKGROUND_COLOR,
    });
    this.chatContainer?.onNewMessageReceived();
  }

  sendMessage(): void {
    if (!this.textArea.nativeElement.value) return;
    const userInput = this.textArea.nativeElement.value;
    this.addMessage({
      type: this.SENT,
      messageFrom: 'You',
      messageText: userInput,
    });
    this.textArea.nativeElement.value = '';
    this.chatContainer?.onNewMessageSent();

    const payload = {
      user_request: userInput,
    };

    this.isAIBotLoading = true;
    this.ssoAiChatService.getSSOSuggestionSteps(payload).subscribe(
      (response) => {
        this.isAIBotLoading = false;
        this.addBotMessage(response);
      },
      () => {
        this.addBotMessage(this.translate.instant('INTEGRATIONS.SSO_INTEGRATION.ERROR_WHILE_GENERATING_STEPS'));
        this.isAIBotLoading = false;
      },
    );
  }
}
